import localAxios from '../localAxios';
import { QuizQuestionUrl } from './questionApi';

export type CreateBody<TBodyData> = (questionIds: number[]) => TBodyData;

export interface DeleteBulkQuestionsParams<TBodyData> {
  quizId: number;
  questionIds: number[];
  questionsUrl: QuizQuestionUrl;
  createBodyData: CreateBody<TBodyData>;
}

export async function deleteBulkQuestions<TBodyData, TReturnType = any>({
  questionIds,
  questionsUrl,
  quizId,
  createBodyData,
}: DeleteBulkQuestionsParams<TBodyData>) {
  const url = questionsUrl({ quizId, questionId: questionIds });
  const result = await localAxios.delete<TReturnType>(url, {
    data: { ...createBodyData(questionIds) },
  });

  return result.data;
}
